<template>
  <el-dialog
    :title="$t('upgrade_page_views_user_set_delete_account_803')"
    :visible.sync="dialogVisible"
    width="30%"
    append-to-body
    class="delete-account-dialog"
  >
    <div class="m10">{{$t('upgrade_page_views_user_set_delete_account_804')}}</div>
    <div class="m10">
      <el-input
        type="textarea"
        :placeholder="$t('upgrade_page_views_user_set_delete_account_805')"
        v-model="reasion"
        maxlength="500"
        show-word-limit
      >
      </el-input>
    </div>
    <div>
      <div class="m10">{{$t('upgrade_page_views_user_set_delete_account_806')}}</div>
      <div class="m10">{{$t('upgrade_page_views_user_set_delete_account_807')}}</div>
      <ul>
        <li>{{$t('upgrade_page_views_user_set_delete_account_808')}}</li>
        <li>{{$t('upgrade_page_views_user_set_delete_account_809')}}</li>
        <li>{{$t('upgrade_page_views_user_set_delete_account_810')}}</li>
        <li>{{$t('upgrade_page_views_user_set_delete_account_811')}}</li>
        <li>{{$t('upgrade_page_views_user_set_delete_account_812')}}</li>
        <li>{{$t('upgrade_page_views_user_set_delete_account_813')}}</li>
        <li>{{$t('upgrade_page_views_user_set_delete_account_814')}}</li>
      </ul>
    </div>
    <div>
      <el-button type="primary" v-loading="loading" @click="deleteAccount()"
        >{{$t('upgrade_page_views_user_set_delete_account_815')}}</el-button
      >
      <el-button @click="hidden()">{{$t('upgrade_page_layout_header_42')}}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import i18n from '@/locales/index'
import IM from '@/plugins/im';
export default {
  name: 'DeleteAccount',
  data() {
    return {
      reasion: '',
      loading: false,
      dialogVisible: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteAccount() {
      if (this.loading) {
        return;
      } else {
        this.$http
          .post('/user/delete/add', { reasion: this.reasion })
          .then(() => {
            this.$confirm({
              message: i18n.t('upgrade_page_views_user_set_delete_account_816'),
              title:
                i18n.t('upgrade_page_views_user_set_delete_account_817'),
              showCancelButton: false,
              confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
              closeOnClickModal: false,
              customClass: 'dialog-center'
            }).then(() => {
              IM.imSdkLogout();
              this.$store.dispatch('im/updateUnreadCount', 0);
              this.$store.dispatch('im/selectConversation', null);
              this.$store.dispatch('app/resetToken');
              this.$router.replace({
                path: '/'
              });
            });
          });
      }
    },
    show() {
      this.dialogVisible = true;
    },
    hidden() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="scss">
.delete-account-dialog {
  line-height: 1.4;
  .m10 {
    margin: 10px 0;
  }
  li {
    margin: 10px 0;
  }
  input,
  button,
  textarea,
  input:focus,
  textarea:focus,
  .el-button--primary {
    border: 1px solid #dcdfe6 !important;
  }
}
</style>
